export type Size = {width: number; height: number}
export namespace Size {
  export function scale({width, height}: Size, factor: number) {
    return {
      width: width * factor,
      height: height * factor
    }
  }
}
